import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Link } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const images = [
  'https://www.camaramadrid.es/documents/20182/40518471/2025.10.03+NW++NW+campus+C%C3%A1mara.jpg/f61f2b7b-0e6f-468c-a3a3-82cbe14d7a06?t=1759485062087',
  '/images/11.jpg',
  '/images/16.jpg',
  '/images/5.jpg',
  '/images/6.jpg'
];

function Header() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: '#ffffff' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src="https://nexotur.com/wp-content/uploads/imagenes_web_antigua/fotos/1/Logo_CamaraMadrid_RGB.jpg" 
              alt="Logo Cámara Madrid" 
              style={{ height: 50 }}
            />
          </Box>

          

        </Toolbar>
      </AppBar>


   <AppBar 
        position="static" 
        sx={{ 
          background: 'linear-gradient(to right, #ff5a4b, #920000)', 
          boxShadow: 'none', 
          py: 1 
        }}
      >
        <Toolbar sx={{ justifyContent: 'center' }}>
          <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold' }}>
            Cámara Oficial de Comercio, Industria y Servicios de Madrid
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ width: "100%" , mt:1 }}>
        <Slider {...settings}>
          {images.map((src, index) => (
            <Box key={index}>
              <Box
                component="img"
                src={src}
                alt={`Imagen ${index + 1}`}
                sx={{
                  width: '100%',
                  height: { xs: 150, md: 290 },
                  objectFit: 'cover'
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </>
  );
}

export default Header;